

const Lock = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="66"
      height="78"
      viewBox="0 0 66 78"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 24.9043V54.736C0 57.5184 1.4569 60.0896 3.822 61.4809L29.178 76.3967C31.5431 77.7879 34.4569 77.7879 36.822 76.3967L62.178 61.4809C64.5431 60.0896 66 57.5184 66 54.736V24.9043C66 22.1217 64.5431 19.5506 62.178 18.1593L36.822 3.24349C34.4569 1.85227 31.5431 1.85227 29.178 3.24349L3.822 18.1593C1.4569 19.5506 0 22.1217 0 24.9043Z"
        fill="url(#paint0_linear_6_2)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.8214 33C30.3914 33 28.4214 34.97 28.4214 37.4C28.4214 39.4501 29.8236 41.1729 31.7214 41.6614V46.2H33.9214V41.6614C35.8192 41.1729 37.2214 39.4501 37.2214 37.4C37.2214 34.97 35.2515 33 32.8214 33ZM32.8214 39.6C31.6084 39.6 30.6214 38.613 30.6214 37.4C30.6214 36.1869 31.6084 35.2 32.8214 35.2C34.0344 35.2 35.0214 36.1869 35.0214 37.4C35.0214 38.613 34.0344 39.6 32.8214 39.6Z"
        fill="black"
        fillOpacity="0.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7214 14.3C20.7214 7.62809 26.1505 2.2 32.8236 2.2C39.4944 2.2 44.9214 7.62809 44.9214 14.3L45.0006 23.9184H46.9938L47.1214 14.3C47.1214 6.40338 40.7191 0 32.8236 0C24.9237 0 18.5214 6.40338 18.5214 14.3V24.2H10.8214V57.2H54.8214V24.2H20.7214V14.3ZM52.6214 54.9999H13.0214V26.3999H52.6214V54.9999Z"
        fill="black"
        fillOpacity="0.4"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6_2"
          x1="-11.6199"
          y1="6.989"
          x2="-26.5116"
          y2="78.1737"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C8E6C9" />
          <stop offset="1" stopColor="#FFECB3" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Lock;
